import { Controller } from "stimulus";

// Legacy binary .doc has no client-side viewer library (docx-preview only
// understands the real .docx XML format — feeding it a .doc blob throws).
// The server extracts plain text instead (the same extraction the AI
// standardisation pipeline already relies on) and this renders it read-only.
export default class extends Controller {
  static values = { url: String };
  static targets = ["spinner", "container"];

  declare readonly urlValue: string;
  declare readonly spinnerTarget: HTMLElement;
  declare readonly containerTarget: HTMLElement;

  connect() {
    this.loadPreview();
  }

  async loadPreview() {
    try {
      const response = await fetch(this.urlValue);
      if (!response.ok)
        throw new Error(`Failed to load preview (${response.status})`);
      const data = await response.json();

      // Untrusted candidate-supplied content — set via textContent, never
      // interpolated into an HTML string, so it can't execute as markup.
      const pre = document.createElement("pre");
      pre.className = "whitespace-pre-wrap font-sans text-sm text-gray-800 p-4";
      pre.textContent = data.text;
      this.containerTarget.appendChild(pre);
    } catch (error) {
      console.error("Failed to load .doc preview:", error);
      this.containerTarget.innerHTML = `
        <p class="text-sm text-gray-500 p-4 text-center">Preview isn't available for this older .doc format, but standardisation works normally.</p>
      `;
    } finally {
      this.spinnerTarget.classList.add("hidden");
    }
  }
}
